export const toDate = (value: string | Date | null | undefined): Date  | undefined => {
  if (value === null || value === undefined) return undefined;
  if (value instanceof Date) return value;
  try {
    return new Date(value);
  } catch (e) {
    console.error('Invalid date string:', value);
    return undefined;
  }
};
